<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-holiday-holiday-dialog-create
          v-if="$hasPermissionTo(['create holidays'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="holidayFilter"
          :items="holidayTypes"
          item-text="text"
          item-value="value"
          label="Holiday Types"
          placeholder=" All / National / Regional"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in holiday name here"
          append-icon="search"
          label="Search holiday"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredHolidays"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.is_national="{ item }">
        <div>
          <span class="font-weight-bold">
            {{ item.is_national? 'Yes' : 'No' }}
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <setup-holiday-holiday-dialog-edit
          v-if="$hasPermissionTo(['update holidays'])"
          :holiday="item"
          @updated="loadData"
        />
        <span class="mx-1" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupHolidayHolidayDialogCreate: () => import('@/components/hris/setup/holiday/holiday/DialogCreate'),
      SetupHolidayHolidayDialogEdit: () => import('@/components/hris/setup/holiday/holiday/DialogEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Holidays',
            align: 'left',
            value: 'name',
          },
          {
            text: 'National Holiday',
            value: 'is_national',
            align: 'center',
          },
          {
            text: '',
            value: 'action',
            align: 'left',
          },
        ],
        search: '',
        tableLoading: true,
        holidays: [],
        holidayFilter: 'all',
        holidayTypes: [
          { value: 'all', text: 'All' },
          { value: 'regional', text: 'Regional' },
          { value: 'national', text: 'National' },
        ],
      }
    },
    computed: {
      filteredHolidays () {
        if (this.holidayFilter === 'all') {
          return this.holidays
        }
        
        return this.holidays.filter((holiday) => {
          if (this.holidayFilter === 'national') {            
            return holiday.is_national === 1
          } else {
            return holiday.is_national === 0
          }
        })
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$api.hrisHolidays().list()
          .then(res => {
            this.holidays = _.orderBy(res.data, ['name'], ['asc'])

            this.tableLoading = false
          })
      },
    },
  }
</script>
